export default __webpack_public_path__ + "static/media/Boots of the Strange Beyond.7298ad11.jpg";